module.exports = __webpack_public_path__ + "img/bio-icon.228406e7.png";